export default "__VITE_ASSET__B3bqzkD8__"